import { useLazyQuery, useQuery } from "@apollo/client";
import { SIGNATURE_LINKS } from "../signature-link.queries";
import {
  SignatureLinksQuery,
  SignatureLinksQueryVariables,
} from "../../../__generated__/SignatureLinksQuery";

export const useSignatureLinks = (variables: SignatureLinksQueryVariables) => {
  return useQuery<SignatureLinksQuery, SignatureLinksQueryVariables>(SIGNATURE_LINKS, {
    variables,
  });
};

export const useLazySignatureLinks = () => {
  return useLazyQuery<SignatureLinksQuery, SignatureLinksQueryVariables>(
    SIGNATURE_LINKS
  );
};
